import { AppModule } from 'app/module';
import { CONSENT_GROUPS, hasConsent, onConsentChange, openConsentSettings } from 'util/consent';
import Template from './template.hbs';
import './styles.scss';

export class EbCompanySocialMediaFeed extends AppModule {
    setTemplate() {
        this.template = Template;
        if (module.hot) {
            module.hot.accept('./template.hbs', () => {
                this.template = Template;
                this.render();
            });
        }
    }

    domBindings() {
        return {
            socialMediaFeeds: ['.m-ebCompanySocialMediaFeed'],
            feedConsentLink: '.m-ebCompanySocialMediaFeed__feedConsentLink',
            feed: '.m-ebCompanySocialMediaFeed__feed',
            fallback: '.m-ebCompanySocialMediaFeed__fallback',
        };
    }

    getPropsFromDom() {
        return {
            socialMediaId: this.dom.socialMediaFeeds[0].getAttribute('data-id'),
            socialMediaUniqueId: this.dom.socialMediaFeeds[0].getAttribute('data-Uuid'),
            isInstagram: this.dom.socialMediaFeeds[0].getAttribute('data-isInstagram'),
            isTikTok: this.dom.socialMediaFeeds[0].getAttribute('data-isTikTok'),
            socialMediaUrl: this.dom.socialMediaFeeds[0].getAttribute('data-url'),
            platform: this.dom.socialMediaFeeds[0].getAttribute('data-platform'),
        };
    }

    ready() {
        this.initMediaBlock(this.props);
    }

    domEvents() {
        if (this.dom.feedConsentLink) {
            this.dom.feedConsentLink.addEventListener('click', () => {
                openConsentSettings();
            });
        }
    }

    initMediaBlock(feed) {
        let isInitialized = false;
        const init = async () => {
            if (isInitialized || !this.hasConsent()) {
                return;
            }

            if (feed.isInstagram === 'true') {
                await this.initInstagramFeed(feed);
            } else if (feed.isTikTok === 'true') {
                await this.initTiktokFeed(feed);
            }

            isInitialized = true;
        };

        onConsentChange(init);
        init();
    }

    async initInstagramFeed(feed) {
        const { socialMediaUniqueId } = feed;

        // Create the iframe element
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.instagram.com/${socialMediaUniqueId}/embed`;
        iframe.width = '345';
        iframe.height = '425';
        iframe.style.border = '1px solid #caced3';
        iframe.style.borderRadius = '3px';
        iframe.style.margin = '0 auto';
        iframe.style.display = 'block';
        iframe.allowTransparency = 'true';

        // Append the iframe to the container div
        this.dom.feed.replaceChild(iframe, this.dom.fallback);
    }

    async initTiktokFeed(feed) {
        // Define the social media variables
        const { socialMediaUrl } = feed;
        const { socialMediaUniqueId } = feed;
        const { socialMediaId } = feed;

        const blockquote = document.createElement('blockquote');
        blockquote.classList.add('tiktok-embed');
        blockquote.setAttribute('cite', socialMediaUrl);
        blockquote.setAttribute('data-unique-id', socialMediaUniqueId);
        blockquote.setAttribute('data-embed-type', 'creator');
        blockquote.setAttribute('data-embed-from', 'oembed');
        blockquote.style.maxWidth = '720px';
        blockquote.style.minWidth = '288px';

        const section = document.createElement('section');
        const link = document.createElement('a');
        link.target = '_blank';
        link.href = `https://www.tiktok.com/${socialMediaId}?refer=creator_embed`;
        link.textContent = socialMediaId;

        section.appendChild(link);
        blockquote.appendChild(section);

        this.dom.feed.replaceChild(blockquote, this.dom?.fallback);

        const script = document.createElement('script');
        script.src = 'https://www.tiktok.com/embed.js';
        script.async = true;

        document.body.appendChild(script);
    }

    hasConsent() {
        return hasConsent(CONSENT_GROUPS.performance);
    }
}
